import React from "react";
import styled from "styled-components";
import SummonerTable from "./components/SummonerTable";
import Footer from "./components/Footer";
import Logo from "./rto.png";
import Ikon from "./ikon.png";
import Clock from "./Countdown";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #222;
`;

const FlexWrapper = styled.div`
  flex: 1;
`;

const Header = styled.h1`
  color: white;
  font-size: 48px;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.4) 1px 1px;
  @media (max-width: 768px) {
    font-size: 24px;
  }
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 150px;
  }
`;

const PoweredBy = styled.div`
  font-size: 26px;
`;

const FooterCountdown = styled.div`
  color: white;
  font-size: 18px;
  text-align: center;
`;

const Metaphor = styled.div`
img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100px;
`;

const Link = styled.a``;

export default function App() {
  return (
    <Container>
      <Header>
        <img src={Logo} alt="RTO" />
        <PoweredBy>Powered By</PoweredBy>
        <Link href="https://ikon.gg">
          <img src={Ikon} alt="Ikon" />
        </Link>
        Race2Challenger Leaderboard
        <FooterCountdown>
          <Metaphor>
            <Clock />
          </Metaphor>
        </FooterCountdown>
      </Header>
      <FlexWrapper>
        <SummonerTable />
      </FlexWrapper>

      <Footer />
    </Container>
  );
}
